import { API, graphqlOperation } from "aws-amplify";
import { updateService } from "../mutations";

// performDeleteAccount - call graphQl, no try-catch
// handleCreateAccount - with try-catch
// processUpdateAccount - process for lambda

export const sanitizeServiceLambda = ({ account, history, ...rest }) => rest;

export const sanitizeService = (service) => {
  const sanitized = sanitizeServiceLambda(service);
  const { owner, createdAt, updatedAt, ...rest } = sanitized;
  return rest;
};

// mutations.updateInvoice
export const performUpdateService = async (service) => {
  const serviceInput = sanitizeService(service);
  return API.graphql(graphqlOperation(updateService, { input: serviceInput }));
};
